import { readAnalyticsConsent } from './consent';

function canTrackMetaClientEvents(): boolean {
  if (process.env.NODE_ENV !== 'production') return false;
  if (
    process.env.NEXT_PUBLIC_VERCEL_ENV &&
    process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production'
  ) {
    return false;
  }
  return true;
}

/** Pixel standard events for the ads funnel. Does not change lib/analytics/metaPixel.ts. */
export function trackMetaStandardEvent(params: {
  eventName: string;
  eventId: string;
  data?: Record<string, unknown>;
}): void {
  try {
    if (typeof window === 'undefined') return;
    if (
      !canTrackMetaClientEvents() ||
      readAnalyticsConsent() !== 'accepted' ||
      !params.eventId ||
      !params.eventName
    ) {
      return;
    }

    const storageKey = `meta_evt_${params.eventName}_${params.eventId}`;
    try {
      if (window.sessionStorage.getItem(storageKey)) return;
    } catch {
      // Storage blocked (private mode / in-app browser): still fire once here.
    }

    try {
      window.fbq?.('track', params.eventName, params.data ?? {}, { eventID: params.eventId });
    } catch {
      // fbq / blocked pixel must never throw into a submit handler.
    }
    try {
      window.sessionStorage.setItem(storageKey, '1');
    } catch {
      // Same as above.
    }
  } catch {
    // localStorage / consent / sessionStorage / fbq must never throw into a user action.
  }
}
